import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';

export type CoverImage = {
    alt: string;
    src: string;
    srcSet: string;
};

type Props = {
    className?: string;
    image: CoverImage;
    lazyLoadImages?: boolean;
    rel: string;
    to: string;
};

export const CoverImageTile = ({ className, image, lazyLoadImages, rel, to }: Props) => (
    <div className={className ? cn('relative overflow-hidden', className) : 'relative h-full w-1/2 overflow-hidden'}>
        <RouteLink
            className="block h-full w-full"
            rel={rel}
            to={to}
        >
            <img
                alt={image.alt}
                className="absolute inset-0 m-auto max-h-[101%] max-w-[101%]"
                loading={lazyLoadImages ? 'lazy' : 'eager'}
                src={image.src}
                srcSet={image.srcSet}
            />
        </RouteLink>
    </div>
);
